import { Component, OnInit } from '@angular/core';
import { ActiveUserLocalDataService } from '../../../shared/services/active-user-local-data.service';
import { CourierService } from '../../../shared/services/courier.service';
import { ContactsService } from '../../../shared/services/contacts.service';
import { GetActiveVoucherDto, GetActiveVoucherRequest } from '../../../shared/models/courier.models';
import { GetContactsRequest, GetContactsResponse } from '../../../shared/models/contacts.models';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent implements OnInit {
  voucher: GetActiveVoucherDto | null = null;
  clientId: number | null | undefined = null;
  contacts: GetContactsResponse | null | undefined = null;
  flag: boolean = true;
  clientContacts: { originalRow: string, name: string, phones: string[] }[] = [];
  organizationContacts: { originalRow: string, name: string, phones: string[] }[] = [];
  displayedClientContacts: string[] = [];
  displayedOrganizationContacts: string[] = [];

  constructor(
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private courierService: CourierService,
    private contactsService: ContactsService
  ) {}

  ngOnInit() {
    this.refreshActiveVoucher();
  }

  async refreshActiveVoucher() {
    const request: GetActiveVoucherRequest = {};
    try {
      const response = await this.courierService.getActiveVouchers(request).toPromise();
      this.voucher = response?.voucher ?? null;
      if (this.voucher) {
        this.activeUserLocalDataService.setActiveCourierVoucher(this.voucher);
        this.clientId = this.voucher.clientsId;
        this.loadContacts();
      } else {
        this.activeUserLocalDataService.setActiveCourierVoucher(null);
        console.error('No active voucher found');
        this.loadOrganizationContacts();
      }
    } catch (error) {
      console.error('Error fetching active voucher:', error);
      this.loadOrganizationContacts();
    }
  }

  async loadContacts() {
    if (this.clientId !== null && this.clientId !== undefined) {
      const request: GetContactsRequest = { clientId: this.clientId };
      try {
        this.contacts = await this.contactsService.getContacts(request).toPromise();
        if (this.contacts) {
          this.splitAndLogContacts(this.contacts.clientContacts, this.contacts.organizationContacts);
        } else {
          console.warn('No contacts data received from the API');
        }
      } catch (error) {
        console.error('Error fetching contacts:', error);
      }
    } else {
      console.error('Client ID is not available');
    }
  }
  
  async loadOrganizationContacts() {
    try {
      this.contacts = await this.contactsService.getContacts({}).toPromise();
      if (this.contacts) {
        this.splitAndLogContacts(this.contacts.clientContacts, this.contacts.organizationContacts);
      } else {
        console.warn('No organization contacts data received from the API');
      }
    } catch (error) {
      console.error('Error fetching organization contacts:', error);
    }
  }
  
  splitAndLogContacts(clientContacts: string | null | undefined, organizationContacts: string | null | undefined) {
    this.clientContacts = clientContacts ? this.splitContacts(clientContacts) : [];
    this.organizationContacts = organizationContacts ? this.splitContacts(organizationContacts) : [];
  }
  
  splitContacts(contacts: string): { originalRow: string, name: string, phones: string[] }[] {
    return contacts.split('\r\n')
      .filter(row => row.trim() !== '')
      .map(row => this.extractContact(row));
  }
  
  formatPhoneNumber(phone: string): string {
    return `<a href="tel:${phone.replace(/\s+/g, '')}">${phone}</a>`;
  }

  extractContact(row: string): { originalRow: string, name: string, phones: string[] } {
    const nameMatch = row.match(/^(.*?)#/);
    const phonesMatch = row.match(/#(.*?)#/g);
    const name = nameMatch ? nameMatch[1].trim() : '';
    const phones = phonesMatch ? phonesMatch.map(phone => phone.replace(/#/g, '').trim()) : [];
    const formattedPhones = phones.map(phone => this.formatPhoneNumber(phone));
    let originalRow = row;
    phones.forEach((phone, index) => {
      originalRow = originalRow.replace(`#${phone}#`, formattedPhones[index]);
    });
    return { originalRow, name, phones };
  }

  

}